export const PUBLISH_VERSION = '1.5';
export const TRACK_API_URL = 'https://catalog.saygames.io/api/v1/track';
export const RTL_LANGUAGES = ['ar', 'he', 'iw'];
